import { DocRenderer } from '@cyntler/react-doc-viewer';
import { ClickAwayListener } from '@material-ui/core';
import { useContext } from 'react';

import { ClickAwayContext } from './context';

export const AudioRenderer: DocRenderer = ({ mainState }) => {
  const src = mainState.currentDocument?.uri || '';
  const type = mainState.currentDocument?.fileType;
  const { onClickAway } = useContext(ClickAwayContext);
  return (
    <div className="w-full h-screen flex justify-center items-center">
      <ClickAwayListener onClickAway={onClickAway} touchEvent={false}>
        <audio controls>
          <source src={src} type={type} />
        </audio>
      </ClickAwayListener>
    </div>
  );
};
AudioRenderer.fileTypes = ['audio/mpeg', 'audio/mp3', 'audio/ogg', 'audio/wav'];
AudioRenderer.weight = 1;
